// src/services/garageService.js
import api from '../utils/api'; // Assuming you have an API utility

class GarageService {
  /**
   * Fetch all garages with filters
   */
  async fetchGarages(params = {}) {
    const queryParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, value);
      }
    });

    const response = await api.get(`/garages?${queryParams.toString()}`);
    return response.data;
  }

  /**
   * Fetch single garage by ID
   */
  async fetchGarageById(id) {
    const response = await api.get(`/garages/${id}`);
    return response.data;
  }

  /**
   * Create new garage
   */
  async createGarage(data) {
    const response = await api.post('/garages', data);
    return response.data;
  }

  /**
   * Update garage
   */
  async updateGarage(id, data) {
    const response = await api.patch(`/garages/${id}`, data);
    return response.data;
  }

  /**
   * Delete garage
   */
  async deleteGarage(id) {
    const response = await api.delete(`/garages/${id}`);
    return response.data;
  }

  /**
   * Update approval status
   */
  async updateApprovalStatus(id, status) {
    const response = await api.patch(`/garages/${id}/approval`, { status });
    return response.data;
  }

  /**
   * Add review to garage
   */
  async addReview(id, reviewData) {
    const response = await api.post(`/garages/${id}/reviews`, reviewData);
    return response.data;
  }

  /**
   * Bulk import garages
   */
  async bulkImport(garages) {
    const response = await api.post('/garages/bulk-import', garages);
    return response.data;
  }

  /**
   * Fetch statistics
   */
  async fetchStatistics() {
    const response = await api.get('/garages/statistics/overview');
    return response.data;
  }

  /**
   * Search nearby garages
   */
  async searchNearby(lat, lng, radius = 10) {
    const response = await api.get(`/garages/nearby?lat=${lat}&lng=${lng}&radius=${radius}`);
    return response.data;
  }

  /**
   * Get vehicle makes for specialization
   */
  async fetchVehicleMakes() {
    const response = await api.get('/garages/vehicle-makes');
    return response.data;
  }
}

export default new GarageService();